import { render, staticRenderFns } from "./ManagementTable.vue?vue&type=template&id=99883d30&scoped=true"
import script from "./ManagementTable.vue?vue&type=script&lang=js"
export * from "./ManagementTable.vue?vue&type=script&lang=js"
import style0 from "./ManagementTable.vue?vue&type=style&index=0&id=99883d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99883d30",
  null
  
)

export default component.exports